import React from "react";
import { FaEdit, FaUser } from "react-icons/fa";
import { Card } from "../UI/DesignStandards";
import { PrimaryButton, SecondaryButton } from "../UI/DesignStandards/Buttons";
import { FormField } from "../UI/DesignStandards/Forms";

const NameSection = ({
  fullName,
  editingName,
  loading,
  onEdit,
  onSave,
  onCancel,
  onChange,
}) => {
  return (
    <Card className="mb-0" aria-labelledby="name-heading">
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div
            className="w-10 h-10 bg-brand-cream rounded-lg flex items-center justify-center"
            aria-hidden="true"
          >
            <FaUser className="h-5 w-5 text-brand-muted" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-3 gap-2">
            <h3 id="name-heading" className="heading-display text-lg">
              Full Name
            </h3>
            {!editingName ? (
              <SecondaryButton
                onClick={onEdit}
                icon={FaEdit}
                className="!px-3 !py-2 text-sm"
                aria-label="Edit full name"
              >
                Edit
              </SecondaryButton>
            ) : (
              <div className="flex gap-2">
                <PrimaryButton
                  onClick={onSave}
                  disabled={loading}
                  loading={loading}
                  loadingText="Saving..."
                  aria-label={loading ? "Saving name" : "Save name changes"}
                >
                  Save
                </PrimaryButton>
                <SecondaryButton
                  onClick={onCancel}
                  className="!px-3 !py-2 text-sm"
                  aria-label="Cancel name changes"
                >
                  Cancel
                </SecondaryButton>
              </div>
            )}
          </div>

          {!editingName ? (
            <div className="p-3 card-inset">
              <p className="text-brand-charcoal font-medium">
                {fullName || (
                  <span className="text-brand-muted italic">Not set</span>
                )}
              </p>
            </div>
          ) : (
            <div className="mt-3">
              <FormField
                label="Full Name"
                type="text"
                id="fullName"
                name="fullName"
                value={fullName}
                onChange={onChange}
                placeholder="Enter your full name"
                className="mb-0"
              />
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export default NameSection;
